/**
 * BilingualTextField — side-by-side or tabbed TR/EN text input pair
 *
 * @param {string}   labelKey    — i18n key prefix (e.g. "title")
 * @param {string}   nameTr      — form field name for TR
 * @param {string}   nameEn      — form field name for EN
 * @param {string}   valueTr
 * @param {string}   valueEn
 * @param {function} onChange    — (name, value) => void
 * @param {boolean}  multiline   — use textarea instead of input
 * @param {boolean}  required
 * @param {string}   placeholderTr
 * @param {string}   placeholderEn
 */
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

export default function BilingualTextField({
  labelTr,
  labelEn,
  nameTr,
  nameEn,
  valueTr = '',
  valueEn = '',
  onChange,
  multiline = false,
  required = false,
  placeholderTr = 'Türkçe...',
  placeholderEn = 'English...',
  rows = 3,
}) {
  const Field = multiline ? Textarea : Input;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      <div className="space-y-1.5">
        <Label className="text-xs font-semibold text-gray-600 flex items-center gap-1">
          {labelTr || nameTr}
          {required && <span className="text-rose-500">*</span>}
          <span className="ml-auto text-[10px] bg-cyan-100 text-cyan-700 px-1.5 py-0.5 rounded font-bold">TR</span>
        </Label>
        <Field
          name={nameTr}
          value={valueTr}
          onChange={(e) => onChange(nameTr, e.target.value)}
          placeholder={placeholderTr}
          rows={multiline ? rows : undefined}
          className="text-sm"
        />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs font-semibold text-gray-600 flex items-center gap-1">
          {labelEn || nameEn}
          {required && <span className="text-rose-500">*</span>}
          <span className="ml-auto text-[10px] bg-emerald-100 text-emerald-700 px-1.5 py-0.5 rounded font-bold">EN</span>
        </Label>
        <Field
          name={nameEn}
          value={valueEn}
          onChange={(e) => onChange(nameEn, e.target.value)}
          placeholder={placeholderEn}
          rows={multiline ? rows : undefined}
          className="text-sm"
        />
      </div>
    </div>
  );
}
